import React from 'react';
import { usePermissionsStore } from '@/stores/usePermissionsStore';
import { isPerfilAnalista } from '@/utils/perfil';

export function usePodeEditar(codigoEscrita: string): boolean {
  const temPermissao = usePermissionsStore((s) => s.hasPermission(codigoEscrita));
  const isSuper = usePermissionsStore((s) => s.isSuper);
  const analista = React.useMemo(() => isPerfilAnalista(), []);
  return temPermissao && (isSuper || analista);
}
